// Extracted from Dashboard/index.web.jsx on 2026-10-02.
export default {
  'columns-by-breakpoint': { xs: 1, sm: 1, md: 1, lg: 3, xl: 4, xxl: 4 },
  breakpoints: { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200, xxl: 1400 },
  'grid-gap': 10,
  'visible-rows': 2,
  'bottom-padding': 24,
  'minimum-row-height': 170,
  'row-height-settle-delays': [0, 40, 120, 260, 500, 900],
  'tall-device-widgets': [
    'ConnectedDeviceGroups',
    'TechnologyBridgeDevices',
    'ManualRoadClosureDevices',
    'TechnologyBridgeSirenDevices',
  ],
} as const;
